module.exports = __webpack_public_path__ + "img/vinheta.46ac937e.png";